import React from 'react';
import { ChatControllerBaseConfig } from '../../../base';
import { ThreadContextController } from './contextSelectInterface';
import { ThreadContextItem } from '@varos/assistant-sdk';

export function createThreadContextController(
    config: ChatControllerBaseConfig
): ThreadContextController {
    const {
        kernel: {
            provider: { createFormController },
        },
    } = config;

    const formController = createFormController();

    // Define available context options (only implemented ones)
    const contextOptions = [
        {
            label: 'Solution',
            value: 'solution',
            description: 'Add a solution context',
        },
        {
            label: 'Collection',
            value: 'collection',
            description: 'Add a collection context',
        },
    ];
    return {
        useProps(context, props) {
            // Helper function to get display text for context items
            const getDisplayText = (item: ThreadContextItem) => {
                switch (item.kind) {
                    case 'solution':
                        return `${item.solutionId}`;
                    case 'collection':
                        return `${item.collectionId}`;
                    default:
                        return `${item.kind}`;
                }
            };

            // Handle navigation for context selection (only supports nested screens)
            const handleContextTypeSelection = (contextType: string) => {
                if (contextType === 'solution' || contextType === 'collection') {
                    props.navigation.setCurrentScreen(contextType);
                }
            };

            return {
                items: props.selected.map((item, index) => ({
                    id: `${item.kind}_${index}`, // Generate ID from kind and index
                    type: item.kind,
                    display: getDisplayText(item),
                    onRemove: () => props.onRemoveContext(`${item.kind}_${index}`),
                })),
                onAddContextType: handleContextTypeSelection,
                options: contextOptions,
                navigation: {
                    currentScreen: props.navigation.currentScreen,
                    onBack: () => props.navigation.setCurrentScreen('main'),
                },
                current: (() => {
                    switch (props.navigation.currentScreen) {
                        case 'solution':
                            return {
                                kind: 'solution' as const,
                                onSelect: (solution: any) => {
                                    console.log(
                                        '[ThreadContext] onSelectSolution called with:',
                                        solution
                                    );
                                    console.log('[ThreadContext] Submitting to form:', {
                                        items: [solution],
                                    });
                                    props.onSolution(solution);
                                    props.navigation.setCurrentScreen('main');
                                    props.onClose?.();
                                },
                                onBack: () => props.navigation.setCurrentScreen('main'),
                            };
                        case 'collection':
                            return {
                                kind: 'collection' as const,
                                onSelectCollection: (collection: any) => {
                                    props.onCollection(collection);
                                    props.navigation.setCurrentScreen('main');
                                    props.onClose?.();
                                },
                                onBack: () => props.navigation.setCurrentScreen('main'),
                            };
                        default:
                            return undefined;
                    }
                })(),
            };
        },
    };
}
